import React from "react";
import styled from "styled-components";
import foodbank from "../imgs/foodbank.png";

const CallOutWrapper = styled.div`
  transition: filter 0.3s ease-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px 20px;
  background: ${({ theme }) => theme.colors.primary};
  p {
    font-size: 14px;
    color: #528fcc;
    margin: 0 0 10px 0;
  }
  img {
    width: 130px;
  }
`;

const HSAButton = styled.a`
  background: ${({ theme }) => theme.colors.blue};
  border-radius: 30px;
  color: white;
  border: none;
  padding: 5px 20px;
  font-size: 10px;
  margin-top: 10px;
  text-decoration: none;
`;

const CallOut = props => {
  return (
    <CallOutWrapper blur={props.blur}>
      <img src={foodbank} alt="Newcastle West End Foodbank" />
      <HSAButton href="https://newcastlewestend.foodbank.org.uk/" target="_blank">
        Learn More
      </HSAButton>
    </CallOutWrapper>
  );
};

export default CallOut;



// WEBPACK FOOTER //
// ./src/components/CallOut.js